import { toast } from "sonner";
import api, { errMsg } from "../lib/api";

export const PENDING_PERIODS = [
  { key: "15d", label: "Last 15 Days" }, { key: "1m", label: "Last 1 Month" },
  { key: "3m", label: "Last 3 Months" }, { key: "6m", label: "Last 6 Months" },
  { key: "1y", label: "Last 1 Year" }, { key: "all", label: "All Time" },
];

export function PeriodChips({ period, setPeriod, prefix }) {
  return (
    <div className="flex flex-wrap gap-2">
      {PENDING_PERIODS.map((p) => (
        <button key={p.key} onClick={() => setPeriod(p.key)} data-testid={`${prefix}-period-${p.key}`}
          className={`btn-sm rounded-lg px-4 font-semibold ${period === p.key ? "bg-slate-900 text-white" : "bg-white border border-slate-300 text-slate-700"}`}>
          {p.label}
        </button>
      ))}
    </div>
  );
}

export function reportPrint(url) {
  api.get(url).then(({ data }) => {
    const w = window.open("", "_blank"); if (!w) return;
    w.document.write(data); w.document.close(); w.onload = () => w.print();
  }).catch((e) => toast.error(errMsg(e)));
}

export function reportPdf(url, fname) {
  toast.info("Generating PDF…");
  api.get(url, { responseType: "blob" }).then(({ data }) => {
    const a = document.createElement("a"); a.href = URL.createObjectURL(data);
    a.download = fname; a.click(); setTimeout(() => URL.revokeObjectURL(a.href), 60000);
  }).catch((e) => toast.error(errMsg(e)));
}
